import diff, { Difference } from 'microdiff';

type ChangedValue = {
  old: string;
  new: string;
};

export type ChangesMap<T> = Partial<Record<keyof T, ChangedValue>>;

export function buildProposalValueChanges<T extends Record<string, unknown>>(
  reference: T,
  proposal: T,
): ChangesMap<T> {
  const differences: Difference[] = diff(reference, proposal);

  const changes = differences.reduce<ChangesMap<T>>((acc, difference) => {
    const key = difference.path.join('.') as keyof T;

    switch (difference.type) {
      case 'REMOVE':
        acc[key] = { old: difference.oldValue, new: '' };
        break;
      case 'CHANGE':
        acc[key] = {
          old: difference.oldValue,
          new: difference.value,
        };
        break;
      case 'CREATE':
        acc[key] = { old: '', new: difference.value };
        break;
    }

    return acc;
  }, {});

  return changes;
}
